import React from "react"
import NewHeader from "../components/layout/NewHeader"
import Modal from "../components/layout/modal"
import { defPath } from '../config/defPath'

import { Controls } from "../components/layout/menu_help"

// Import Swiper
import Swiper, { Pagination } from 'swiper'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'


function App() {

  const handleClickGameStart = (e: any) => {
    // @ts-ignore
    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Button',
      'event_label': 'Start game',
      'interaction': 'true',
      'component_name': 'Modo_Carrera_Game',
      'element_text': `${e.currentTarget.textContent || "Jugar ahora"}`,
    });
    window.location.href = '/estadio-aguila/juego'
  }
  // const up = window.drupalSettings.user.uid
  // if(up == 0){
  //   window.location.href = '/estadio-aguila/iniciar-sesion'
  // }

  const widthSize = window.innerWidth;
  if (widthSize <= 565) {
    window.scrollTo(0, 20)
  }
  
  React.useEffect(() => {
    const swiper = new Swiper('.swiperInst', {
      modules: [Pagination],
      spaceBetween: 10,
      speed: 200,
      direction: 'horizontal',
      // loop: true,
      slidesPerView: 1,
      observer: true,
      centeredSlides: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
    });

    // let redirect = false
    
    // swiper.on('slideChange', (e) => {
    //   if (e.isEnd) {
    //     redirect = true
    //     swiper.on('sliderFirstMove', (e) =>{
    //       window.location.href = '/estadio-aguila/juego'
    //     })
    //   }
    // })
  }, [])
  return (
    <>

      {/* Page HTML */}

      <section id="king-home" className="ar__instructions">
        {/* <Logo />
            <BtnMenu />
            <BtnMenuProfile /> */}
        <NewHeader />
        <Controls isStadium= {false} />
        <Modal />

        <div className="ar__instructions__box blur-slow">
          {/* <div className="ar__instructions__title title_2">JUEGA Y GANA</div>
                <p className="medium_30" >INSTRUCCIONES</p> */}

          <div className="swiper swiperInst">
            <div className="swiper-wrapper">
              <div className="swiper-slide">
                <picture className="instructions-image">
                  <source media="(min-width: 700px)" srcSet={`${defPath}/assets/images/instructions/step1_big15-op1.jpeg`} />
                  <img src={`${defPath}/assets/images/instructions/step1-op.jpg`} alt="" />
                </picture>
                <div className="text">
                  <p className="subtitleSmall whiteShadow mob">Toca y arrastra</p>
                  {/* <p className="subtitleSmall whiteShadow desk">haz clic y arrastra</p> */}
                  <p className="subtitle_light" >para moverte</p>
                </div>
              </div>
              <div className="swiper-slide">
                <picture className="instructions-image">
                  <source media="(min-width: 700px)" srcSet={`${defPath}/assets/images/instructions/step2_big15-op.jpg`} />
                  <img src={`${defPath}/assets/images/instructions/step2-op.jpg`} alt="" />
                </picture>
                <div className="text">
                  <p className="subtitleSmall whiteShadow">evita que pase la pelota</p>
                  <p className="subtitle_light">Y trata de anotar goles en la portería rival.</p>
                </div>
              </div>
              <div className="swiper-slide">
                <picture className="instructions-image">
                  <source media="(min-width: 700px)" srcSet={`${defPath}/assets/images/instructions/step3_big15-op.jpg`} />
                  <img src={`${defPath}/assets/images/instructions/step3-op.jpg`} alt="" />
                </picture>
                <div className="text">
                  <p className="subtitleSmall whiteShadow">obtén poderes especiales</p>
                  <p className="subtitle_light">Golpea los íconos con la pelota para ganar puntos, sumar tiempo y obtener poderes especiales.</p>
                </div>
              </div>
              <div className="swiper-slide">
                <picture className="instructions-image">
                  <source media="(min-width: 700px)" srcSet={`${defPath}/assets/images/instructions/step4_big15-op.jpg`} />
                  <img src={`${defPath}/assets/images/instructions/step4-op.jpg`} alt="" />
                </picture>
                <div className="text">
                  <p className="subtitleSmall whiteShadow">evita los obstaculos</p>
                  <p className="subtitle_light">Si golpeas las barreras la pelota rebotará y podrías recibir goles en contra. </p>
                </div>
              </div>
            </div>
            <div className="swiper-pagination" ></div>
          </div>

          <a href="/estadio-aguila/juego" onClick={handleClickGameStart} className="ar__btn-primary" >Jugar ahora</a>
        </div>
      </section>
    </>
  )
}

export default App
